import { render } from "./user-creditor.vue?vue&type=template&id=5f9c3e36&scoped=true"
import script from "./user-creditor.vue?vue&type=script&lang=js"
export * from "./user-creditor.vue?vue&type=script&lang=js"

import "./user-creditor.vue?vue&type=style&index=0&id=5f9c3e36&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9c3e36"]])

export default __exports__